import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, FilterIcon, ChevronDownIcon, ArrowUpIcon, ArrowDownIcon, CheckCircleIcon, XCircleIcon, AlertCircleIcon, ClockIcon } from 'lucide-react';
export const CandidatesList = () => {
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [filterOpen, setFilterOpen] = useState(false);
  const handleSort = field => {
    if (field === sortField) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };
  const candidates = [{
    id: 1,
    name: 'Sarah Johnson',
    position: 'Senior Developer',
    status: 'Completed',
    score: 92,
    source: 'LinkedIn',
    date: '2023-06-15',
    botRisk: 'Low'
  }, {
    id: 2,
    name: 'Michael Chen',
    position: 'Product Manager',
    status: 'In Progress',
    score: 78,
    source: 'Indeed',
    date: '2023-06-18',
    botRisk: 'Low'
  }, {
    id: 3,
    name: 'Emily Rodriguez',
    position: 'UX Designer',
    status: 'Completed',
    score: 85,
    source: 'Referral',
    date: '2023-06-10',
    botRisk: 'Low'
  }, {
    id: 4,
    name: 'David Kim',
    position: 'Marketing Director',
    status: 'Scheduled',
    score: null,
    source: 'Company Website',
    date: '2023-06-22',
    botRisk: 'Unknown'
  }, {
    id: 5,
    name: 'Lisa Wang',
    position: 'Sales Manager',
    status: 'Flagged',
    score: 45,
    source: 'LinkedIn',
    date: '2023-06-14',
    botRisk: 'High'
  }, {
    id: 6,
    name: 'James Wilson',
    position: 'Frontend Developer',
    status: 'Completed',
    score: 88,
    source: 'Indeed',
    date: '2023-06-12',
    botRisk: 'Low'
  }, {
    id: 7,
    name: 'Olivia Martinez',
    position: 'Data Scientist',
    status: 'In Progress',
    score: 72,
    source: 'LinkedIn',
    date: '2023-06-19',
    botRisk: 'Medium'
  }, {
    id: 8,
    name: 'Robert Taylor',
    position: 'DevOps Engineer',
    status: 'Scheduled',
    score: null,
    source: 'Referral',
    date: '2023-06-23',
    botRisk: 'Unknown'
  }];
  return <div data-id="element-642">
      <div className="mb-6" data-id="element-643">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-644">Candidates</h1>
        <p className="text-gray-600" data-id="element-645">
          View and manage all candidates in your pipeline.
        </p>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-646">
        <div className="p-6 border-b border-gray-200" data-id="element-647">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-648">
            <div className="relative w-full md:w-80" data-id="element-649">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-650">
                <SearchIcon size={18} className="text-gray-400" data-id="element-651" />
              </div>
              <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:border-indigo-500 sm:text-sm" placeholder="Search candidates..." data-id="element-652" />
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-653">
              <button onClick={() => setFilterOpen(!filterOpen)} className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-654">
                <FilterIcon size={16} className="mr-2" data-id="element-655" />
                Filter
                <ChevronDownIcon size={16} className="ml-1" data-id="element-656" />
              </button>
              <div className="relative inline-block text-left" data-id="element-657">
                <button className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-658">
                  All Positions
                  <ChevronDownIcon size={16} className="ml-1" data-id="element-659" />
                </button>
              </div>
              <div className="relative inline-block text-left" data-id="element-660">
                <button className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-661">
                  All Statuses
                  <ChevronDownIcon size={16} className="ml-1" data-id="element-662" />
                </button>
              </div>
              <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-663">
                Add Candidate
              </button>
            </div>
          </div>
          {filterOpen && <div className="mt-4 p-4 border border-gray-200 rounded-md bg-gray-50" data-id="element-664">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-665">
                <div data-id="element-666">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-667">
                    Source
                  </label>
                  <select className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-668">
                    <option data-id="element-669">All Sources</option>
                    <option data-id="element-670">LinkedIn</option>
                    <option data-id="element-671">Indeed</option>
                    <option data-id="element-672">Referral</option>
                    <option data-id="element-673">Company Website</option>
                  </select>
                </div>
                <div data-id="element-674">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-675">
                    Score Range
                  </label>
                  <div className="flex items-center space-x-2" data-id="element-676">
                    <input type="number" min="0" max="100" placeholder="Min" className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-677" />
                    <span data-id="element-678">to</span>
                    <input type="number" min="0" max="100" placeholder="Max" className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-679" />
                  </div>
                </div>
                <div data-id="element-680">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-681">
                    Date Range
                  </label>
                  <div className="flex items-center space-x-2" data-id="element-682">
                    <input type="date" className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-683" />
                    <span data-id="element-684">to</span>
                    <input type="date" className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-685" />
                  </div>
                </div>
              </div>
              <div className="mt-4 flex justify-end space-x-2" data-id="element-686">
                <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-687">
                  Reset
                </button>
                <button className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-688">
                  Apply Filters
                </button>
              </div>
            </div>}
        </div>
        <div className="overflow-x-auto" data-id="element-689">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-690">
            <thead className="bg-gray-50" data-id="element-691">
              <tr data-id="element-692">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('name')} data-id="element-693">
                  <div className="flex items-center" data-id="element-694">
                    Candidate
                    {sortField === 'name' && (sortDirection === 'asc' ? <ArrowUpIcon size={14} className="ml-1" data-id="element-695" /> : <ArrowDownIcon size={14} className="ml-1" data-id="element-696" />)}
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-697">
                  Position
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('status')} data-id="element-698">
                  <div className="flex items-center" data-id="element-699">
                    Status
                    {sortField === 'status' && (sortDirection === 'asc' ? <ArrowUpIcon size={14} className="ml-1" data-id="element-700" /> : <ArrowDownIcon size={14} className="ml-1" data-id="element-701" />)}
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('score')} data-id="element-702">
                  <div className="flex items-center" data-id="element-703">
                    Score
                    {sortField === 'score' && (sortDirection === 'asc' ? <ArrowUpIcon size={14} className="ml-1" data-id="element-704" /> : <ArrowDownIcon size={14} className="ml-1" data-id="element-705" />)}
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-706">
                  Source
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('date')} data-id="element-707">
                  <div className="flex items-center" data-id="element-708">
                    Date
                    {sortField === 'date' && (sortDirection === 'asc' ? <ArrowUpIcon size={14} className="ml-1" data-id="element-709" /> : <ArrowDownIcon size={14} className="ml-1" data-id="element-710" />)}
                  </div>
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-711">
                  Bot Risk
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-712">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-713">
              {candidates.map(candidate => <tr key={candidate.id} className="hover:bg-gray-50" data-id="element-714">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-715">
                    <div className="flex items-center" data-id="element-716">
                      <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center" data-id="element-717">
                        {candidate.name.charAt(0)}
                      </div>
                      <div className="ml-4" data-id="element-718">
                        <div className="text-sm font-medium text-gray-900" data-id="element-719">
                          {candidate.name}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-720">
                          candidate{candidate.id}@example.com
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-721">
                    {candidate.position}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-722">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                        ${candidate.status === 'Completed' ? 'bg-green-100 text-green-800' : candidate.status === 'In Progress' ? 'bg-blue-100 text-blue-800' : candidate.status === 'Scheduled' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`} data-id="element-723">
                      {candidate.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-724">
                    {candidate.score ? <div className="flex items-center" data-id="element-725">
                        <span className={`font-medium ${candidate.score >= 80 ? 'text-green-600' : candidate.score >= 60 ? 'text-yellow-600' : 'text-red-600'}`} data-id="element-726">
                          {candidate.score}/100
                        </span>
                      </div> : <span data-id="element-727">—</span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-728">
                    {candidate.source}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-729">
                    {new Date(candidate.date).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-730">
                    <div className="flex items-center" data-id="element-731">
                      {candidate.botRisk === 'Low' && <CheckCircleIcon size={16} className="text-green-500 mr-1" data-id="element-732" />}
                      {candidate.botRisk === 'Medium' && <AlertCircleIcon size={16} className="text-yellow-500 mr-1" data-id="element-733" />}
                      {candidate.botRisk === 'High' && <XCircleIcon size={16} className="text-red-500 mr-1" data-id="element-734" />}
                      {candidate.botRisk === 'Unknown' && <ClockIcon size={16} className="text-gray-400 mr-1" data-id="element-735" />}
                      <span className={`text-sm ${candidate.botRisk === 'Low' ? 'text-green-600' : candidate.botRisk === 'Medium' ? 'text-yellow-600' : candidate.botRisk === 'High' ? 'text-red-600' : 'text-gray-500'}`} data-id="element-736">
                        {candidate.botRisk}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-737">
                    <Link to={`/dashboard/candidates/${candidate.id}`} className="text-indigo-600 hover:text-indigo-900 mr-3" data-id="element-738">
                      View
                    </Link>
                    <button className="text-gray-600 hover:text-gray-900" data-id="element-739">
                      More
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-740">
          <div className="flex-1 flex justify-between sm:hidden" data-id="element-741">
            <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-742">
              Previous
            </button>
            <button className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-743">
              Next
            </button>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-744">
            <div data-id="element-745">
              <p className="text-sm text-gray-700" data-id="element-746">
                Showing <span className="font-medium" data-id="element-747">1</span> to{' '}
                <span className="font-medium" data-id="element-748">8</span> of{' '}
                <span className="font-medium" data-id="element-749">24</span> candidates
              </p>
            </div>
            <div data-id="element-750">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-751">
                <button className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-752">
                  <span className="sr-only" data-id="element-753">Previous</span>
                  &larr;
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-754">
                  1
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-indigo-50 text-sm font-medium text-indigo-600 hover:bg-gray-50" data-id="element-755">
                  2
                </button>
                <button className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-756">
                  3
                </button>
                <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-757">
                  ...
                </span>
                <button className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-758">
                  <span className="sr-only" data-id="element-759">Next</span>
                  &rarr;
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>;
};